import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '../../../../components/shell/page-header';
import { EmptyState } from '../../../../components/ui/empty-state';
import { MyWorkPage } from '../../../../components/workbench/my-work-page';
import { useSession } from '../../../../lib/session';

export const Route = createFileRoute('/subdomain/admin/_staff/')({
  component: StaffHome,
  staticData: { board: true },
});

/** Specialists and leads land on their own board ("My work"); the other roles' dashboards come in Sprint 5. */
function StaffHome() {
  const { data: session } = useSession();
  const role = session?.user.role;
  if (role === 'specialist' || role === 'lead_specialist') return <MyWorkPage />;
  return <ComingSoonHome name={session?.user.name} />;
}

// TODO(Sprint 5): the real dashboards (A02.1 and the role views) replace this landing page.
function ComingSoonHome({ name }: { name: string | undefined }) {
  const first = name?.split(/\s+/)[0];
  return (
    <>
      <PageHeader title={first ? `Hi, ${first}` : 'Dashboard'} description="Your workspace is being set up." />
      <div className="rounded-(--mbm-component-radius-card) border border-border-line bg-surface-card">
        <EmptyState
          title="Dashboard coming soon"
          description="Clients, tasks and reviews will show up here as each area goes live."
        />
      </div>
    </>
  );
}
